import React, { useState, useImperativeHandle } from 'react';
import classnames from 'classnames';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { apiHolder as api, apis } from 'api';
import moment from 'moment';
import { reminderOpts } from '@web-schedule/components/CreateBox/util';
import { MailActions, useActions, useAppSelector } from '@web-common/state/createStore';
import IconCard from '@web-common/components/UI/IconCard';
import TaskMailModal from './TaskMailModal';
import styles from '../mailInfo.module.scss';
import taskStyle from './taskMail.module.scss';
import { getIn18Text } from 'api';
import { remWaittingId } from '@web-mail-write/util';
import { mailContentHasVar, textHaveVar } from '@web-mail-write/components/SendMail/utils';
export const initTaskMailState = () => {
    const cur = moment();
    cur.second(0).millisecond(0);
    let minutes = cur.minutes();
    minutes = Math.ceil(minutes / 15) * 15;
    cur.minutes(minutes);
    const taskMail = {
        endDate: cur,
        endTime: cur.clone(),
        nonEndTime: false,
        nonEndDate: false,
        enmuReminders: reminderOpts(false)[0].value,
        expireRemindEveryday: true,
    };
    return taskMail;
};
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const TaskMailBtn = React.forwardRef((prop, ref) => {
    const mailActions = useActions(MailActions);
    const [modalVisible, setModalVisible] = useState(false);
    const infoStatus = useAppSelector(state => state.mailReducer.currentMail.status);
    const curAccount = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.optSender; });
    const currentMailId = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.cid; });
    const currentMailTitle = useAppSelector(state => { var _a, _b; return (_b = (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.title; });
    const isMainAccount = curAccount === null || curAccount === void 0 ? void 0 : curAccount.isMainAccount;
    const taskMailShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.taskMailShow;
    const conferenceShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.conferenceShow;
    const praiseMailShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.praiseMailShow;
    const receiver = useAppSelector(state => state.mailReducer.currentMail.receiver);
    const scheduleDate = useAppSelector(state => state.mailReducer.currentMail.scheduleDate);
    const isDyncGroupSend = useAppSelector(state => state.mailReducer.currentMail.isDyncGroupSend);
    const clickTaskMail = () => {
        if (!isMainAccount)
            return;
        remWaittingId(currentMailId, true);
        trackApi.track('pcMail_click_addButton_writeMailPage', { buttonName: getIn18Text('RENWU') });
        const hasVar = textHaveVar(currentMailTitle);
        const contentHasVar = mailContentHasVar();
        if (hasVar.customVar || hasVar.systemVar || contentHasVar) {
            message.warning({
                content: '任务邮件暂不支持插入变量',
            });
            return;
        }
        if (scheduleDate) {
            message.warning({
                content: getIn18Text('RENWUYOUJIANZAN'),
            });
            return;
        }
        if (receiver.some(item => item.mailMemberType === 'bcc')) {
            setModalVisible(true);
            return;
        }
        showTaskMail();
    };
    const showTaskMail = () => {
        const taskMail = initTaskMailState();
        mailActions.doTaskShow(true);
        mailActions.doTaskMailSetting(true);
        mailActions.doTaskMailChange(taskMail);
    };
    useImperativeHandle(ref, () => ({
        click: clickTaskMail,
    }));
    const content = prop.hidden || taskMailShow || conferenceShow || praiseMailShow || isDyncGroupSend ? null : (React.createElement("div", { "data-test-id": "write-subject-task", className: classnames(styles.btnWrapper, taskStyle.btnWrapper, { [styles.disabled]: !isMainAccount }), onClick: () => {
            clickTaskMail();
        } },
        React.createElement("span", { className: styles.btnIcon },
            React.createElement(IconCard, { type: "taskMail" })),
        React.createElement("span", { className: styles.btnText }, getIn18Text('RENWU'))));
    return (React.createElement(React.Fragment, null,
        content,
        React.createElement(TaskMailModal, { isModalVisible: modalVisible, setIsModalVisible: setModalVisible, showTaskMail: showTaskMail })));
});
export default TaskMailBtn;
